module.exports = __webpack_public_path__ + "static/media/7glink.11b03d27.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/7glink.png
// module id = 63
// module chunks = 0